import React, { useRef, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import { useTranslation } from "react-i18next";
import { Fade, List, ListItem, Tooltip } from "@material-ui/core";
import LicenseAbout from '../About/LicenseAbout';
import ApiKeyGenerateModal from "../../../components/Modals/ApiKeyGenerator/ApiKeyGenerator";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import clsx from "clsx";

const StyledMenu = withStyles({
    paper: { border: '1px solid #d3d4d5' }
})((props) => (
    <Menu
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
        }}
        {...props}
    />
));

const useStyles = makeStyles({
    borderRadius: { borderRadius: 3 },
    text: { marginLeft: 15 },
    hide: { display: "none" },
    menu: { paddingTop: 0 },
    langMenu: { right: -100 },
    customSubTooltip: {
        // I used the rgba color for the standard "secondary" color
        backgroundColor: 'rgba(11, 41, 73, 0.89);',
        height: 38,
        top: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ffffff",
        fontSize: 12,
        left: -4
    },
    customSubArrow: {
        color: 'rgba(11, 41, 73, 0.89);',
    },
});

const useListStyles = makeStyles((theme) => ({
    root: { backgroundColor: theme.palette.background.paper },
    nested: { paddingLeft: theme.spacing(4) }
}));


export default function HelpSection({ sideBarOpen }) {
    const classes = useStyles();
    const listClasses = useListStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [show, setShow] = useState(false);
    const [showAPIGenerator, setShowAPIGenerator] = useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        setAnchorEl(null);
    };

    const { t } = useTranslation();

    return (
        sideBarOpen ? (
            <>
                <div
                    className="link cover-list" onClick={handleClick}>
                    <div
                        className={`list-has-subitem expanded hover-me`} >
                        <IconButton
                            className="menu-item"
                            aria-controls="customized-menu"
                            aria-haspopup="true"
                            variant="contained"
                            disabled
                        >
                            <HelpOutlineIcon style={{ color: '#4F6E90', fontSize: 22 }} />
                        </IconButton>

                        <Fade in={sideBarOpen} timeout={{ enter: 500, exit: 100 }}>
                            <div style={{ width: "100%" }}
                                className={clsx({
                                    [classes.hide]: !sideBarOpen,
                                })} >
                                <span className="list-item-text language-text" >
                                    {t("CONTENT.SIDEBAR.HELP")}
                                </span>
                            </div>
                        </Fade>
                        {show && <LicenseAbout open={show} setOpen={setShow} />}
                        {showAPIGenerator ? <ApiKeyGenerateModal setOpen={setShowAPIGenerator} /> : null}
                    </div>

                </div>
                <StyledMenu
                    dense="true"
                    id="customized-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    className={classes.langMenu}
                >
                    <List
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        className={listClasses.root}
                    >
                        {/* <Collapse in={open} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem className={classes.nested}>
                                <ListItemText primary="Licence Type: Freemium" />
                            </ListItem>
                            <ListItem className={classes.nested}>
                                <ListItemText primary="Licence Number: 0123-4567-89" />
                            </ListItem>
                            <ListItem className={classes.nested}>
                                <ListItemText primary="Contact us: 0850 AUTOMMATE" />
                            </ListItem>
                        </List>
                    </Collapse> */}
                        <ListItem button onClick={() => setShow('about')}>
                            <ListItemText primary={t('CONTENT.HELP-SECTIONS.ABOUT')} />
                        </ListItem>
                        <ListItem button onClick={() => setShow('license')}>
                            <ListItemText primary={t('CONTENT.HELP-SECTIONS.LICENSE')} />
                        </ListItem>
                        {/* <ListItem button>
                        <ListItemText primary={t('CONTENT.HELP-SECTIONS.DOCUMENTATION')}/>
                    </ListItem> */}
                        <ListItem button onClick={() => setShowAPIGenerator(!showAPIGenerator)}>
                            <ListItemText primary={t('CONTENT.HELP-SECTIONS.API-KEY-GENERATE')} />
                        </ListItem>
                    </List>
                </StyledMenu>
            </>
        ) : (
            <div
                className="link cover-list-collapsed help">
                <div
                    className={`list-has-subitem collapsed`}>
                    <Tooltip title={t("CONTENT.SIDEBAR.HELP")} placement="right" classes={{
                        tooltip: classes.customSubTooltip,
                        arrow: classes.customSubArrow
                    }} arrow>
                        <IconButton
                            className="menu-item"
                            style={{ padding: 8 }}
                            aria-controls="customized-menu"
                            aria-haspopup="true"
                            variant="contained"
                            onClick={handleClick}
                        >
                            <HelpOutlineIcon style={{ color: '#4F6E90' }} />
                        </IconButton>
                    </Tooltip>
                    <StyledMenu
                        dense="true"
                        id="customized-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        className={classes.langMenu}
                    >
                        <List
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                            className={listClasses.root}
                        >
                            {/* <Collapse in={open} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem className={classes.nested}>
                                <ListItemText primary="Licence Type: Freemium" />
                            </ListItem>
                            <ListItem className={classes.nested}>
                                <ListItemText primary="Licence Number: 0123-4567-89" />
                            </ListItem>
                            <ListItem className={classes.nested}>
                                <ListItemText primary="Contact us: 0850 AUTOMMATE" />
                            </ListItem>
                        </List>
                    </Collapse> */}
                            <ListItem button onClick={() => setShow('about')}>
                                <ListItemText primary={t('CONTENT.HELP-SECTIONS.ABOUT')} />
                            </ListItem>
                            <ListItem button onClick={() => setShow('license')}>
                                <ListItemText primary={t('CONTENT.HELP-SECTIONS.LICENSE')} />
                            </ListItem>
                            {/* <ListItem button>
                        <ListItemText primary={t('CONTENT.HELP-SECTIONS.DOCUMENTATION')}/>
                    </ListItem> */}
                            <ListItem button onClick={() => setShowAPIGenerator(!showAPIGenerator)}>
                                <ListItemText primary={t('CONTENT.HELP-SECTIONS.API-KEY-GENERATE')} />
                            </ListItem>
                        </List>
                    </StyledMenu>
                    {show && <LicenseAbout open={show} setOpen={setShow} />}
                    {showAPIGenerator ? <ApiKeyGenerateModal setOpen={setShowAPIGenerator} /> : null}
                </div>
            </div>
        )

    );
}
